import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import * as firebase from "firebase/app";
import { AuthService } from "./../shared/services/auth.service";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: "app-bill",
  templateUrl: "./bill.html"
})
export class BillComponent implements OnInit, OnDestroy {
  communityId: string;
  private authState: firebase.User | null;
  activeRouteIndex: number;
  routeSubscription: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.communityId = "";
    this.authState = this.authService.getAuthState();
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => this.activeRouteIndex = params.index);
  }
  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/bill.component.ts